<div class="container-fluid">
	<div class="row">
		<div class="col-md-4">
			<h3 class="prealert-title text-center text-md-left">Estima el precio del envío</h3>
		</div>
	</div>
	<form [formGroup]="pageForm" (ngSubmit)="onSubmit()">
		<div class="row">
			<div class="form-group col-md-3">
				<input class="form-control" type="text" placeholder="Peso LB/Vol" formControlName="weight">
				<div *ngIf="submitted && f.weight.errors?.required" class="invalid-feedback d-block">
					Campo obligatorio
				</div>
			</div>
			<div class="form-group col-md-3">
				<input class="form-control" type="text" placeholder="Total" readonly [(ngModel)]="total"
					[ngModelOptions]="{standalone: true}">
			</div>
			<div class="cl-12 col-md-3 text-center text-md-left">
				<button type="submit" class="btn btn-primary rounded">
					Calcular
				</button>
			</div>
		</div>
	</form>
</div>